import { IconsTypes } from '@/components/shared/Icons';
import { DepartmentPageSlug } from '@/types';

interface IDepartmentInfoCard {
  iconName: IconsTypes;
  titleKey: string;
  textKey: string;
}

interface IDepartmentPagesData {
  withExpositionsInfo?: boolean;
  infoCards: IDepartmentInfoCard[];
}

export const departmentPagesData: Record<DepartmentPageSlug, IDepartmentPagesData> = {
  'department-of-dendrology': {
    withExpositionsInfo: true,
    infoCards: [
      {
        iconName: IconsTypes.DENDROLOGY_TREE,
        titleKey: 'tree-title',
        textKey: 'tree-text',
      },
      {
        iconName: IconsTypes.FOREST,
        titleKey: 'forest-title',
        textKey: 'forest-text',
      },
      {
        iconName: IconsTypes.BUSH,
        titleKey: 'bush-title',
        textKey: 'bush-text',
      },
      {
        iconName: IconsTypes.BUSH_WITH_BERRIES,
        titleKey: 'bush-with-berries-title',
        textKey: 'bush-with-berries-text',
      },
      {
        iconName: IconsTypes.SALLOW,
        titleKey: 'sallow-title',
        textKey: 'sallow-text',
      },
      {
        iconName: IconsTypes.ROSE,
        titleKey: 'rose-title',
        textKey: 'rose-text',
      },
    ],
  },
  'department-of-floriculture': {
    infoCards: [
      {
        iconName: IconsTypes.RED_FLOWER,
        titleKey: 'flowers-decor-title',
        textKey: 'flowers-decor-text',
      },
      {
        iconName: IconsTypes.RED_FLOWERS,
        titleKey: 'flowers-title',
        textKey: 'flowers-text',
      },
      {
        iconName: IconsTypes.SEEDLING,
        titleKey: 'seedling-title',
        textKey: 'seedling-text',
      },
      {
        iconName: IconsTypes.GREEN_LEAFS,
        titleKey: 'hemerocallis-title',
        textKey: 'hemerocallis-text',
      },
      {
        iconName: IconsTypes.TULIP,
        titleKey: 'cockerels-title',
        textKey: 'cockerels-text',
      },
      {
        iconName: IconsTypes.GREEN_FLOWERS,
        titleKey: 'hosta-title',
        textKey: 'hosta-text',
      },
    ],
  },
  'department-of-fruit-agriculture': {
    infoCards: [
      {
        iconName: IconsTypes.BERRIES,
        titleKey: 'herbaceous-fruit-plants-title',
        textKey: 'herbaceous-fruit-plants-text',
      },
      {
        iconName: IconsTypes.BUSH_WITH_BERRIES,
        titleKey: 'fruit-and-berry-shrubs-title',
        textKey: 'fruit-and-berry-shrubs-text',
      },
    ],
  },
  'department-of-natural-flora': {
    withExpositionsInfo: true,
    infoCards: [
      {
        iconName: IconsTypes.ENDANGERED,
        titleKey: 'endangered-title',
        textKey: 'endangered-text',
      },
      {
        iconName: IconsTypes.MEDICAL,
        titleKey: 'medicinal-title',
        textKey: 'medicinal-text',
      },
      {
        iconName: IconsTypes.MINIATURE,
        titleKey: 'miniature-title',
        textKey: 'miniature-text',
      },
      {
        iconName: IconsTypes.CEREALS,
        titleKey: 'cereals-title',
        textKey: 'cereals-text',
      },
    ],
  },
  'department-of-tropical-and-subtropical-plants': {
    withExpositionsInfo: true,
    infoCards: [
      {
        iconName: IconsTypes.TROPICAL,
        titleKey: 'subtropical-plants-title',
        textKey: 'subtropical-plants-text',
      },
      {
        iconName: IconsTypes.RED_FLOWERS,
        titleKey: 'endangered-plants-title',
        textKey: 'endangered-plants-text',
      },
      {
        iconName: IconsTypes.SPORE_PLANT,
        titleKey: 'collection-of-spore-plants-title',
        textKey: 'collection-of-spore-plants-text',
      },
      {
        iconName: IconsTypes.SUCCULENTS,
        titleKey: 'collection-of-succulents-title',
        textKey: 'collection-of-succulents-text',
      },
      {
        iconName: IconsTypes.AROIDS,
        titleKey: 'collection-of-aroids-title',
        textKey: 'collection-of-aroids-text',
      },
    ],
  },
};
